/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdTeacherDataMutationRequest,
  PutApiV1PersonIdTeacherDataMutationResponse,
  PutApiV1PersonIdTeacherDataPathParams,
  PutApiV1PersonIdTeacherData400,
  PutApiV1PersonIdTeacherData401,
  PutApiV1PersonIdTeacherData404,
  PutApiV1PersonIdTeacherData500,
} from "../../types/personTeacherController/PutApiV1PersonIdTeacherData.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdTeacherData } from "../../clients/personTeacherController/putApiV1PersonIdTeacherData.ts";

export const putApiV1PersonIdTeacherDataMutationKey = () =>
  [{ url: "/api/v1/person/:id/teacher-data" }] as const;

export type PutApiV1PersonIdTeacherDataMutationKey = ReturnType<
  typeof putApiV1PersonIdTeacherDataMutationKey
>;

export function putApiV1PersonIdTeacherDataMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1PersonIdTeacherDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1PersonIdTeacherDataMutationKey();
  return mutationOptions<
    PutApiV1PersonIdTeacherDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdTeacherData400
      | PutApiV1PersonIdTeacherData401
      | PutApiV1PersonIdTeacherData404
      | PutApiV1PersonIdTeacherData500
    >,
    {
      id: PutApiV1PersonIdTeacherDataPathParams["id"];
      data?: PutApiV1PersonIdTeacherDataMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdTeacherData(id, data, config);
    },
  });
}

/**
 * @description Atualiza a aba Teacher. Cria TeachingStaff caso ainda não exista. Regras legado preservadas: LattesUpdateDate só é gravada quando IsLattes=true; OtherBusinessSector só é preservada quando BusinessSectorId=40. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de docente (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/teacher-data}
 */
export function usePutApiV1PersonIdTeacherData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdTeacherDataMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdTeacherData400
        | PutApiV1PersonIdTeacherData401
        | PutApiV1PersonIdTeacherData404
        | PutApiV1PersonIdTeacherData500
      >,
      {
        id: PutApiV1PersonIdTeacherDataPathParams["id"];
        data?: PutApiV1PersonIdTeacherDataMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdTeacherDataMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdTeacherDataMutationKey();

  const baseOptions = putApiV1PersonIdTeacherDataMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdTeacherDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdTeacherData400
      | PutApiV1PersonIdTeacherData401
      | PutApiV1PersonIdTeacherData404
      | PutApiV1PersonIdTeacherData500
    >,
    {
      id: PutApiV1PersonIdTeacherDataPathParams["id"];
      data?: PutApiV1PersonIdTeacherDataMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdTeacherDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdTeacherData400
      | PutApiV1PersonIdTeacherData401
      | PutApiV1PersonIdTeacherData404
      | PutApiV1PersonIdTeacherData500
    >,
    {
      id: PutApiV1PersonIdTeacherDataPathParams["id"];
      data?: PutApiV1PersonIdTeacherDataMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdTeacherDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdTeacherData400
      | PutApiV1PersonIdTeacherData401
      | PutApiV1PersonIdTeacherData404
      | PutApiV1PersonIdTeacherData500
    >,
    {
      id: PutApiV1PersonIdTeacherDataPathParams["id"];
      data?: PutApiV1PersonIdTeacherDataMutationRequest;
    },
    TContext
  >;
}
